// @ts-strict-ignore
import { Material } from 'three';
import { StringUtils } from '@shared/util/string-utils';
import { IArticleTextureParameters } from './i-article-texture-parameters';

export class CustomArticleTextureParameters implements IArticleTextureParameters {
  private static readonly CUSTOM_ARTICLE_PREFIX: string = 'customArticleTexture:';

  private _textureName: string;
  private _userId: number;
  private _imageHash: string;

  constructor(material: Material, userId: number, imageHash: string) {
    const name = (material as any).hasOwnProperty('map') && (material as any)['map'].name ? (material as any)['map'].name : material.name;
    this._textureName = StringUtils.getFileNameFromUrl(name);
    this._userId = userId;
    this._imageHash = imageHash;
  }

  public getPrefix(): string {
    return CustomArticleTextureParameters.CUSTOM_ARTICLE_PREFIX;
  }

  public getTextureParameters(): string {
    const parametersString: string = `userId=${this._userId}&imageHash=${this._imageHash}`;
    return this.getPrefix() + parametersString;
  }

  public getSpecularMapParameters(): string {
    return null;
  }

  public getNormalMapParameters(): string {
    return null;
  }

  public getTextureExtension(): string {
    if (!this._textureName) {
      return null;
    }
    return StringUtils.getFileSuffix(this._textureName);
  }

  public getSpecularExtension(): string {
    return null;
  }

  public getNormalExtension(): string {
    return null;
  }
}
